import Company from './Company';
import Invoice from './Invoice';
import Tax from './Tax';
import Logistic from './Logistic';
import Deposit from './Deposit';

export default Object.assign(
  {},
  {
    Invoice,
    Tax,
    Logistic,
    Company,
    Deposit,
  },
);
